var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.931115 13.6871C1.21737 13.5202 1.58475 13.6169 1.75167 13.9032C2.41316 15.0375 3.42444 15.8954 4.67154 16.452C4.97414 16.587 5.10996 16.9418 4.97491 17.2444C4.83985 17.547 4.48506 17.6828 4.18246 17.5478C2.73325 16.901 1.51741 15.8836 0.715053 14.5077C0.548125 14.2214 0.64486 13.8541 0.931115 13.6871Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5247 2.53745C11.7136 1.70907 10.5568 1.40352 9.42437 1.72574C9.10565 1.81643 8.77376 1.63157 8.68307 1.31285C8.59239 0.994132 8.77724 0.662241 9.09596 0.571553C10.6465 0.13036 12.2597 0.551578 13.3821 1.6979C13.614 1.93467 13.61 2.31455 13.3732 2.54638C13.1364 2.77822 12.7565 2.77422 12.5247 2.53745Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3522 2.04661C6.18095 1.75295 5.6819 1.57486 5.17496 1.86458C4.66988 2.15324 4.58104 2.66207 4.74931 2.95063L6.76983 6.41552C6.93676 6.70178 6.84003 7.06915 6.55377 7.23608C6.26752 7.40301 5.90014 7.30627 5.73321 7.02002L3.03918 2.40016C2.86793 2.1065 2.36889 1.9284 1.86194 2.21813C1.35686 2.50679 1.26803 3.01562 1.43629 3.30417L4.46708 8.50151C4.63401 8.78777 4.53727 9.15514 4.25102 9.32207C3.96476 9.489 3.59739 9.39226 3.43046 9.10601L2.08344 6.79608C1.9122 6.50242 1.41315 6.32432 0.906208 6.61405C0.401125 6.90271 0.312292 7.41154 0.480558 7.70009L3.51135 12.8974C4.7985 15.1047 7.97479 15.821 10.6684 14.2816C13.3601 12.7432 14.3169 9.67005 13.0328 7.46789L11.0122 4.003C10.841 3.70934 10.3419 3.53124 9.83499 3.82097C9.32991 4.10963 9.24107 4.61846 9.40934 4.90701L10.7564 7.21694C10.837 7.35519 10.859 7.51991 10.8176 7.6745C10.7762 7.82908 10.6747 7.96071 10.5358 8.04012C9.3018 8.74534 8.92363 10.109 9.46387 11.0354C9.63079 11.3216 9.53406 11.689 9.24781 11.8559C8.96155 12.0229 8.59417 11.9261 8.42725 11.6399C7.69707 10.3877 7.99211 8.88002 8.93522 7.81434C9.19887 7.51643 9.28916 7.08307 9.08876 6.7394L6.3522 2.04661Z",
    fill: "#591528"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandIcon);
export default __webpack_public_path__ + "static/media/stand-icon.3c621e9b76e00858bcdb7fd46980d4e6.svg";
export { ForwardRef as ReactComponent };